<template lang="pug">
	.asset-video-create(v-if="showed")
		.card
			.card-header
				i.fa.fa-edit
				span Create Video
			.card-body.collapse.show
				.form-horizontal
					.form-group
						label.col-form-label(for="prependedInput") Title of new video
							.controls
								input.form-control(id="prependedInput" size="16" type="text" v-model="title")
						//-label.label.col-form-label Section template
							.select-group
								select.right-control.custom-select.custom-select-sm(v-on:change="selectTemplate($event.target.value)")
									option(:selected="true" value="none") Select section template
									option(v-for="section in sections" :value="section.codename") {{section.title}}



					.form-actions
						button.btn.btn-primary(type="submit" v-on:click="create()") Create
						button.btn.btn-ghost-dark(type="button" v-on:click="hide()") Cancel
					p.error-text {{error}}
</template>

<script>

	import _ 					from 'lodash';

	import Screen 				from './../../mixins/screen';

	import { Template } 		from './../../services/Template';
	import { Section } 			from "../../services/Section";
	import { Metadata }			from "../../services/Metadata";
	import { Project }			from "../../services/Project";
	import { Asset }			from "../../services/Asset";

	export default {
		name: "AssetVideoCreate",
		mixins: [Screen],
		screen: {
			events: {
				'Video Already Exists': function() {
					this.error = 'Video with this title already exists';
				},
				'Video Error Occurred': function () {
					this.error = 'Video error occurred';
				},
				'Video Created': function (data) {
					this.hide();

					let input = document.createElement('input');
					input.type = 'file';
					input.style.position = 'absolute';
					input.style.left = '0';
					input.style.top = '0';
					input.style.transform = 'scale(0.1)';
					input.style.visibility = 'hidden';
					document.body.appendChild(input);

					input.addEventListener('change', e => {

						let file = e.target.files[0];

						Asset.addVideo(data.guid, file);

						document.body.removeChild(input);

					});

					input.addEventListener('blur', e => {

						document.body.removeChild(input);

					});

					input.click();
				}
			},
			updateOn: [],
			showed: false
		},
		data() {

			this.Template = Template;

			return {
				title: '',
				error: ''
			}
		},
		methods: {
			collectData() {

				this.title = 'New video';
				this.error = null;

				if (!Project.SelectedProject) return;

				this.sections = Object.values(Metadata.TemplateSectionsByTemplateId)[Template.SelectedTemplate.id];

				this.projectId = Project.SelectedProject.id;

				this.videoId = null;

			},

			selectTemplate(sectionCodename) {


				this.section = Section.SectionsByProjectByCodename[this.projectId][sectionCodename];

			},

			create() {

				if (!this.projectId) return;

				Server.sendToSocket({
					CreateNewVideo: {
						title: this.title,
					}
				});


				// this.projectId = null;
				// this.hide();
				// Broadcast.call("Section Created");

			}
		}
	}
</script>


<style lang="sass">

	.asset-video-create
		position: absolute
		z-index: 2000
		left: 0
		top: 0
		right: 0
		bottom: 0
		background-color: rgba(0, 0, 0, 0.6)

		.card
			width: 500px
			position: absolute
			left: 0
			right: 0
			top: 0
			bottom: 0
			margin: auto
			display: flex
			height: 280px
			box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.8)

			input
				width: 460px
				margin-top: 5px

			.btn-ghost-dark
				float: right
				color: #fff

			.select-group
				padding-top: 5px

			select
				font-size: 14px
				color: white
				border: 1px solid #23282c
				background-color: #515b65

			.error-text
				padding-top: 10px
				color: #fd7272

</style>

